export default {
	datetimePickerAccept: 'Aceptar',
	datetimePickerCancel: 'Cancelar',
	datetimePickerClean: 'Limpiar'
};
